import { getCountryForTimezone } from 'countries-and-timezones';

import { isCountryCode } from './countries';

/**
 * Alpha-2 code of the country an IANA time zone most likely belongs to, or
 * `''` when the zone is unknown, has no country (`UTC`, `Etc/GMT+3`) or maps to
 * a code the "From" dropdown does not list.  Zones shared by several
 * countries resolve to the geographically primary one (`Europe/Zurich` → CH);
 * deprecated aliases resolve like their target (`Asia/Calcutta` → IN).
 */
export function countryCodeForTimezone(timeZone) {
    if (typeof timeZone !== 'string' || !timeZone.trim()) return '';
    const code = getCountryForTimezone(timeZone.trim())?.id || '';
    return isCountryCode(code) ? code : '';
}

/**
 * Best guess of the user's country from the browser's time zone, for
 * pre-filling the onboarding "From" field.  `''` when the browser exposes no
 * usable zone, so the dropdown simply stays empty.
 */
export function browserCountryCode() {
    try {
        return countryCodeForTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
    } catch {
        return '';
    }
}
